import { IDatabaseInfo } from '~src/catalog/models/IDatabaseInfo';

import { IContentInfo } from './IContentInfo';
import { IDatabaseContentInfo } from './IDatabaseContentInfo';

export type AnyDatabaseType = IDatabaseInfo | IContentInfo;

export type CommonDatabaseInfo = Pick<IDatabaseContentInfo,
    'connectionType' |
    'dbType'|
    'filePath' |
    'hostName' |
    'contactName'
>;

/**
 * 
 * CommonDatabaseInfo can exist in VPC as one of a few different types, depending on which API it was fetched from:
 * - IDatabaseInfo (getDatabases)
 * - IContentInfo (exploreContent)
 * 
 * In the explorer and other places in the content browsing experience, we want to use a database
 * object in a consistent manner regardless of its original type, so we map its fields to this common
 * interface when passing it down into the view components.
 */
export function getCommonDatabaseInfo(database: AnyDatabaseType): CommonDatabaseInfo {
    // IContentInfo has the information inside the `contentDetail` property.
    if (isContentInfoDatabase(database)) {
        return {
            connectionType: database.contentDetail.connectionType,
            dbType: database.contentDetail.databaseType,
            filePath: database.contentDetail.filePath,
            hostName: database.contentDetail.hostName,
            contactName: database.contentDetail.contactName,
        };
    } else {
        return {
            connectionType: database.connectionType,
            dbType: database.__typename,
            filePath: database.filePath,
            hostName: database.hostName,
            contactName: database.contact? database.contact.name : null,
        };
    }
}

export function getGraphQLId(database: AnyDatabaseType): string {
    return isContentInfoDatabase(database) ? database.contentDetail.graphQLId : '';
}

export function isContentInfoDatabase(database: any): database is IContentInfo {
    return !!(database.contentDetail);
}
